import React from 'react';
import bem from 'utils/bem';
import SelectField from 'forms/fields/SelectField';
import './index.sass';

const { block } = bem('sort-select');

const SortSelect = ({ value = 'popular', onChange }) => {

    const onValueChange = (e) => {
        const value = e.target.value;
        onChange(value);
    }

    const options = [
        { value: 'price-asc', label: 'Цена по возрастанию' },
        { value: 'price-desc', label: 'Цена по убыванию' },
        { value: 'new', label: 'Новое' },
        { value: 'popular', label: 'Популярное' }
    ]

    return (
        <SelectField className={ block() }
                     options={ options } value={ value } onChange={ onValueChange }/>
    )
}

export default SortSelect;
